// Import translation
import i18n from 'i18next';

export const menuTranslationValidate = ({ name }) => {
	const errors = {};

	// ------------------ name ------------------
	if (!name) {
		errors.name = i18n.t('menu:validation.name');
	}

	return errors;
};
